module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_j_melanistic.9256669e.png";